// extracted by mini-css-extract-plugin
export default {"items":"manageDomains_items__f-Tmp","item":"manageDomains_item__gJ7HL","text":"manageDomains_text__M57mY"};